import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import LanguageContext from '../helper/LanguageContext';
import { DE } from '../Languages/DE';
import { EN } from '../Languages/EN';
import MapContainer from '../pages/map';
import Carousel from "react-multi-carousel";
import { BASE_URL } from '../helper/constants';
import YouTube from 'react-youtube';
import Vimeo from '@u-wave/react-vimeo';
import ReactPlayer from 'react-player'
import { withRouter } from "react-router-dom";
import { ARTICLE } from "./../store";
import { connect } from "react-redux";
import PdfPreviewTile from './PdfPreviewTile';
import PdfViewerModal from './PdfViewerModal';
import { buildVideoPosterUrl, buildVideoSrc, getVideoMimeType, isNativeVideoAttachment } from '../utils/chatVideo';
import './VideoPlayers.css';


function isPdf(url, fileType, fileName) {
    if (fileType === 'application/pdf') return true;
    const candidate = (fileName || url || '').toString();
    return /\.pdf(\?|$)/i.test(candidate);
}

function VideoPlayers({ url, type, isPlaying, fileType, viewArticle: propViewArticle, article, local, isC, removeImage, index, viewArticleFromRedux, fileName, thumbnailUrl, muted = true, fill = false }) {
    let vidRef = useRef(null)
    const [pdfViewer, setPdfViewer] = useState(null);

    const viewArticle = propViewArticle || viewArticleFromRedux;
    const viewFullScreen = async () => {
        if (viewArticle) {
            viewArticle(article)
        }
    }

    const pdfDetected = isPdf(url, fileType, fileName);
    const nativeVideo = isNativeVideoAttachment({ fileType, fileUrl: url, url: local, name: fileName, attachedFileName: fileName });
    const pdfDisplayName = (fileName || (typeof url === 'string' ? url.split('/').pop() : '') || 'document.pdf').split('?')[0];
    const openPdf = useCallback(() => {
        const href = local ? local : (typeof url === 'string' ? ((url.startsWith('http') || url.startsWith('blob:')) ? url : BASE_URL + url) : '');
        if (href) setPdfViewer({ url: href, name: pdfDisplayName });
    }, [local, url, pdfDisplayName]);

    if (pdfDetected) {
        const pdfSrc = local || (typeof url === 'string' ? ((url.startsWith('http') || url.startsWith('blob:')) ? url : BASE_URL + url) : '');
        return (
            <>
                <PdfPreviewTile
                    pdfUrl={pdfSrc}
                    fileName={pdfDisplayName}
                    onClick={openPdf}
                    onRemove={() => removeImage(index)}
                    showRemove={!!isC}
                />
                {pdfViewer && (
                    <PdfViewerModal
                        url={pdfViewer.url}
                        fileName={pdfViewer.name}
                        onClose={() => setPdfViewer(null)}
                    />
                )}
            </>
        );
    }

    return (
        <div style={fill ? { width: '100%', height: '100%' } : (isC ? {} : {})}>
            {
                !fileType && !local ?
                    <ReactPlayer
                        playing={isPlaying}
                        ref={vidRef}
                        url={url}
                        width={fill ? '100%' : undefined}
                        height={fill ? '100%' : undefined}
                        config={{
                            youtube: {
                                playerVars: {
                                    autoplay: 0,
                                    rel: 0,
                                    mute: muted ? 1 : 0,
                                    loop: 1,
                                    disablekb: 1,
                                    controls: 1,
                                    modestbranding: 1
                                }
                            },
                            vimeo: {
                                playerOptions: {
                                    autoplay: 0,
                                    muted: muted ? 1 : 0
                                }
                            }
                        }}
                        controls
                        muted={muted}
                        volume={muted ? 0 : 1}
                    />
                    :
                    <div className="position-relative h-100 w-100">
                        {isC &&
                            <span
                                className="material-symbols-outlined pointer position-absolute remove-image-icon video-players__remove"
                                onClick={() => removeImage(index)}
                                title="Remove"
                            >
                                cancel
                            </span>
                        }
                        {nativeVideo ? (
                            <video
                                className="embed-responsive-item pointer video-players__video"
                                src={buildVideoSrc(!!local, url, fileName) || local}
                                poster={buildVideoPosterUrl(!!local, thumbnailUrl, url) || undefined}
                                controls={!isC}
                                muted={!!isC}
                                playsInline
                                preload={isC ? "metadata" : "auto"}
                                onClick={isC ? undefined : viewFullScreen}
                            >
                                <source src={buildVideoSrc(!!local, url, fileName) || local} type={getVideoMimeType(url)} />
                            </video>
                        ) : (
                            <img className="embed-responsive-item pointer video-players__image"
                                onClick={viewFullScreen}
                                src={!local ? (BASE_URL + url) : local}
                            />
                        )}
                    </div>
            }
        </div>
    );
}
const mapStateToProps = (state) => {
    const { article, drawerOpen } = state;
    return {
        // article: article,
        drawerOpen: drawerOpen,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        viewArticleFromRedux: (article) => dispatch({ type: ARTICLE, article: article }),
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(VideoPlayers));
